import React, { FC, ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: ReactNode;
  /** Compact mode - less padding and smaller text for mobile */
  compact?: boolean;
}

export const PageHeader: FC<PageHeaderProps> = ({
  title,
  subtitle,
  icon,
  action,
  compact = false,
}) => {
  return (
    <header className={`flex flex-col gap-4 ${compact ? '' : 'sm:flex-row sm:items-center sm:justify-between'} pb-4 sm:pb-6 border-b border-brand-border`}>
      <div className="flex flex-col gap-1">
        <h2 className={`font-display text-brand-text font-bold tracking-tight ${
          compact ? 'text-2xl' : 'text-2xl sm:text-3xl lg:text-4xl'
        }`}>
          {title}
        </h2>
        {subtitle && (
          <div className="flex items-center gap-2 text-brand-text-muted">
            {icon && <span className="material-symbols-outlined text-xl">{icon}</span>}
            <span className="text-base font-medium">{subtitle}</span>
          </div>
        )}
      </div>
      {action && (
        <div className="shrink-0">
          {action}
        </div>
      )}
    </header>
  );
};

export default PageHeader;
